import ModalStateGraphic, {
  ModalStateGraphicTheme
} from '@/components/Modals/ModalV2/ModalStateGraphic'
import { ReactNode } from 'react'
import { ModalButtonProps } from '@/components/Modals/ModalV2/types'
import NiceModal from '@ebay/nice-modal-react'
import ConfirmModal from './ConfirmModal'
import { MODAL_ID } from '@/constants/modalId'
import { Icons } from '@/components/Icon'

export interface SuccessModalProps {
  title?: string
  children?: ReactNode
  headerGraphic?: {
    icon: Icons
    theme: ModalStateGraphicTheme
  }
  description: ReactNode
  primaryButton: ModalButtonProps
  secondaryButton: ModalButtonProps
}

export const Success = NiceModal.create(
  ({
    title = 'Success!',
    children,
    description,
    primaryButton,
    secondaryButton,
    headerGraphic = { icon: 'tick', theme: 'default' }
  }: SuccessModalProps) => {
    return (
      <ConfirmModal
        id={MODAL_ID.success}
        className="-mt-1"
        header={{
          component: (
            <ModalStateGraphic
              icon={headerGraphic.icon}
              theme={headerGraphic.theme}
              className="mt-1 mx-auto"
            />
          )
        }}
        title={title}
        primaryButton={primaryButton}
        secondaryButton={secondaryButton}
        description={description}
      >
        {children}
      </ConfirmModal>
    )
  }
)
